import React from "react"

import * as styles from "./PageLayout.module.scss"
import HeaderMain from "../Header/HeaderMain/HeaderMain";
import FooterMain from "../Footer/FooterMain/FooterMain";

import MainHeadline from "../MainHeadline/MainHeadline"
import ContentWrap from "../ContentWrap/ContentWrap";
import GradientBgInner from "../GradientBgInner/GradientBgInner";


const PageLayout = ({
       location,
       children,
       categories,
       maxWidth = false,
       errorPage = false,
       pageType = ""
}) => {
  const rootPath = `${__PATH_PREFIX__}/`
  return (
    <div className={styles.root}>

      <HeaderMain pageType={pageType} />

      <GradientBgInner />
      <main className={styles.contentWrapper}>
        <ContentWrap width={maxWidth ? "maxWidth" : "wide"}>
          {location.pathname === rootPath && (
            <MainHeadline featuredEmoji={"🛀"} />
          )}

          {children}
        </ContentWrap>
      </main>

      <FooterMain />
    </div>
  )
}

export default PageLayout
